import React, { useState } from "react";
import PropTypes from "prop-types";
import { Chip, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { isValidReportRecipientEmail } from "./utils/serviceConfigUtils";

const ImportReportRecipientsEditor = ({
  value = [],
  onChange,
  disabled = false,
}) => {
  const [draftEmail, setDraftEmail] = useState("");
  const [error, setError] = useState("");

  const recipients = Array.isArray(value) ? value : [];

  const addEmail = () => {
    const email = draftEmail.trim();
    if (!email) {
      return;
    }
    if (!isValidReportRecipientEmail(email)) {
      setError("Inserire un indirizzo email valido.");
      return;
    }
    const normalized = email.toLowerCase();
    if (recipients.some((item) => String(item).trim().toLowerCase() === normalized)) {
      setError("Destinatario già presente.");
      return;
    }
    onChange([...recipients, email]);
    setDraftEmail("");
    setError("");
  };

  const removeEmail = (index) => {
    onChange(recipients.filter((_, itemIndex) => itemIndex !== index));
    setError("");
  };

  const handleInputChange = (event) => {
    setDraftEmail(event.target.value);
    if (error) {
      setError("");
    }
  };

  const handleInputKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addEmail();
    }
  };

  return (
    <div className="cm-config-recipients-editor">
      <div className="cm-config-recipients-input-row">
        <input
          className="cm-input"
          type="email"
          value={draftEmail}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          disabled={disabled}
          placeholder="nome@azienda.it"
          aria-label="Nuovo destinatario report import"
          aria-invalid={Boolean(error)}
        />
        <IconButton
          className="cm-config-recipients-add-btn"
          size="small"
          aria-label="Aggiungi destinatario"
          title="Aggiungi destinatario"
          onClick={addEmail}
          disabled={disabled || !draftEmail.trim()}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </div>

      {error ? (
        <p className="cm-config-recipients-error" role="alert">
          {error}
        </p>
      ) : null}

      {recipients.length > 0 ? (
        <div className="cm-config-recipients-chips" role="list" aria-label="Destinatari report import">
          {recipients.map((email, index) => (
            <Chip
              key={`${email}-${index}`}
              label={email}
              size="small"
              className="cm-config-recipient-chip"
              role="listitem"
              onDelete={disabled ? undefined : () => removeEmail(index)}
            />
          ))}
        </div>
      ) : (
        <p className="cm-config-recipients-empty">Nessun destinatario configurato.</p>
      )}
    </div>
  );
};

ImportReportRecipientsEditor.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ImportReportRecipientsEditor;
